import { useFetch } from "lib/useFetch";
import QueryString from "query-string";
import { filterFromQS } from "api/search/filterReducer";
import { features } from "app/features";
import { getPathname } from "lib/routing";

const LANDING_PAGE_STATIC_URL = process.env.PUBLIC_URL + "/api/landingPages/Topics/";
const LANDING_PAGE_CONTENT_URL = "/research/japi/content/Landing_Page/";
const LANDING_PAGE_PREVIEW_URL = "/research/japi/content/preview/Landing_Page/";

export function useFetchLandingPage(topic) {
  const url = shdUseContentApi(topic) ? contentUrl(topic) : staticUrl(topic);
  const [response, isLoading, error] = useFetch(url, null, "GET");
  const pageData = tryParsePage(response);
  return [pageData, isLoading, error];
}

const tryParsePage = (response) => {
  if (!response) return null;
  if (!isPreview() && (!response.data || !response.data.length)) return null;

  try {
    let pageData = isPreview() ? response : response.data[0];
    pageData.reportFilter = parseFilterUrl(pageData.report_filter_url);
    pageData.featuredReportFilter = parseFilterUrl(pageData.featured_report_filter_url);
    return pageData;
  } catch (err) {
    console.error("Error parsing page data", err);
    return null;
  }
};

const parseFilterUrl = (qs) => {
  if (!qs) return qs;
  const result = filterFromQS(QueryString.parse(QueryString.extract(qs + window.location.search.replace("?", "&"))));
  const { sort, ...rest } = result;
  return rest;
}

const shdUseContentApi = (topic) => features["useContentApiForPages"][topic] ?? true;
const contentUrl = (topic) => (isPreview() ? previewUrl(topic) : LANDING_PAGE_CONTENT_URL + topic);
const isPreview = () => getPathname().includes("/preview/");
const previewUrl = (topic) => LANDING_PAGE_PREVIEW_URL + topic;
const staticUrl = (topic) => LANDING_PAGE_STATIC_URL + topic + ".json";
